import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import PageHeader from '../components/PageHeader';
import GalleryGrid from '../components/GalleryGrid';

export default function RobotProgramming() {
  const galleryImages = [
    'https://assets.auxodev.dk/assets/1cab479d-9d2b-49e7-a4f6-be9602b123ca/hero-automation-engineering.jpg',
    'https://assets.auxodev.dk/assets/1cab479d-9d2b-49e7-a4f6-be9602b123ca/automatiske-maskiner-montage.jpg',
  ];

  return (
    <div className="bg-[#0b1017] text-slate-100 min-h-screen">
      <SEO
        title="Robot programmering - JARCon ApS"
        description="Programmering af KUKA, Motoman og UR robotter. Pick & place, palletering, svejsning og automatisk montage."
      />

      <PageHeader
        badge="Automation"
        title="Robot programmering"
        subtitle="Programmering af KUKA, Motoman og UR robotter"
        breadcrumbs={[
          { label: 'Automation', path: '/automation' },
          { label: 'Robot programmering' },
        ]}
        ctaText="Hør om robotløsninger"
        ctaLink="/kontakt"
      />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-8 space-y-8">
            <div className="p-8 rounded-xl bg-[#0e1622] border border-slate-800 space-y-4">
              <span className="text-xs font-open-sans text-cyan-400 uppercase tracking-widest font-semibold block">
                Robotter i produktionen
              </span>
              <h2 className="font-display text-2xl font-bold text-white">
                Programmering af KUKA, Motoman og UR robotter
              </h2>
              <p className="text-slate-300 text-base leading-relaxed">
                Robot programmering: Programmering af KUKA, Motoman og UR robotter.
              </p>
              <p className="text-slate-400 text-sm leading-relaxed">
                Vi sikrer, at robotten bevæger sig optimalt med bløde kurver og minimal slid på gear og mekanik, samtidig med at cyklustiden optimeres. Vi integrerer gribere, vision-kameraer og sikkerhedskredse mod PLC-styringen.
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
              <div className="p-6 rounded-xl bg-[#0e1622] border border-slate-800">
                <h3 className="font-display font-bold text-lg text-white mb-2">Universal Robots (UR)</h3>
                <p className="text-xs text-slate-400 leading-relaxed">
                  Kollaborative robotter (cobots) med fleksibel opsætning, sikkerhedszoner og nem operatørbetjening.
                </p>
              </div>
              <div className="p-6 rounded-xl bg-[#0e1622] border border-slate-800">
                <h3 className="font-display font-bold text-lg text-white mb-2">KUKA Robotter</h3>
                <p className="text-xs text-slate-400 leading-relaxed">
                  Hurtige industrirobotter til tunge laster, præcisionshåndtering, bearbejdning og palletering.
                </p>
              </div>
              <div className="p-6 rounded-xl bg-[#0e1622] border border-slate-800">
                <h3 className="font-display font-bold text-lg text-white mb-2">Yaskawa Motoman</h3>
                <p className="text-xs text-slate-400 leading-relaxed">
                  Høj pålidelighed inden for procesautomation, svejseceller og serieproduktion.
                </p>
              </div>
            </div>

            <GalleryGrid
              title="Robot og automationsgalleri"
              subtitle="Se billeder af robotceller og automationsopstillinger"
              images={galleryImages}
            />
          </div>

          <div className="lg:col-span-4 space-y-6">
            <div className="p-6 rounded-xl bg-[#0e1622] border border-slate-800">
              <h3 className="font-display text-base font-bold text-white mb-4">
                Typiske applikationer
              </h3>
              <ul className="space-y-3 text-xs font-open-sans text-slate-300">
                <li className="flex items-center gap-2">
                  <i className="fa-solid fa-check text-cyan-400" aria-hidden="true" />
                  <span>Emnehåndtering (Pick &amp; Place)</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="fa-solid fa-check text-cyan-400" aria-hidden="true" />
                  <span>Maskinbetjening (CNC tendering)</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="fa-solid fa-check text-cyan-400" aria-hidden="true" />
                  <span>Montage og presningsoperationer</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="fa-solid fa-check text-cyan-400" aria-hidden="true" />
                  <span>Automationsudstyr til skolebrug (EUC-SYD)</span>
                </li>
              </ul>
            </div>

            <div className="p-6 rounded-xl bg-gradient-to-br from-[#0e1622] to-[#070b10] border border-cyan-500/40 text-center space-y-4">
              <span className="text-xs font-open-sans text-cyan-400 uppercase tracking-wider block font-semibold">
                Robotprogrammering
              </span>
              <p className="text-xs text-slate-300">
                Overvejer du at automatisere en proces med robotter? Få en vurdering af mulighederne.
              </p>
              <Link
                to="/kontakt"
                className="w-full inline-flex items-center justify-center gap-2 px-5 py-3 rounded-md bg-cyan-500 hover:bg-cyan-600 text-white font-bold text-xs uppercase tracking-wider transition-all"
              >
                <span>Kontakt os</span>
                <i className="fa-solid fa-arrow-right" aria-hidden="true" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
